module.exports = __webpack_public_path__ + "static/img/nullimage.a9e281f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nullimage.jpg
// module id = +0E3
// module chunks = 84